/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, ReactNode, useState } from 'react';

export interface UserContextType {
  jwt: string;
  setJwt(jwt: string): void;
  isAdmin: boolean;
  setIsAdmin(isAdmin: boolean): void;
}

/**
 * Context for user information
 */
export const UserContext = createContext<UserContextType>({
  jwt: '',
  setJwt: () => {},
  isAdmin: false,
  setIsAdmin: () => {},
});

/**
 * UserProvider Component.
 * Component to provide user information to its children
 * @param props children components
 * @returns UserProvider Component
 */
export const UserProvider = ({ children }: { children: ReactNode }) => {
  const [jwt, setJwt] = useState<string>('');

  const [isAdmin, setIsAdmin] = useState<boolean>(false);

  return (
    <UserContext.Provider
      value={{
        jwt,
        setJwt,
        isAdmin,
        setIsAdmin,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
